import { createSlice, Middleware } from "@reduxjs/toolkit"
import { IIsDetails } from "./types"

type initialState = {
  response: IIsDetails | null
}

export const isDetailsSlice = createSlice({
  name: "isDetails",
  initialState: { response: null } as initialState,
  reducers: {
    setIsDetails(state, action) {
      state.response = action.payload
    }
  }
})

export const { setIsDetails } = isDetailsSlice.actions
export default isDetailsSlice.reducer

export const isDetailsHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
